import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DateRange } from '../date-range';
import { DateRangePickerModalComponent } from './date-range-picker-modal.component';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DateRangePickerModalService {
  /*
   * @note updated on modal close
   */
  selectedDateRange$ = new Subject<DateRange>();

  constructor(private modalService: NgbModal) {}

  openModal(
    dateRangeBounds: DateRange,
    selectedDateRange: DateRange,
    minSelectionCount?: number,
    maxSelectionCount?: number,
    hasCustomSpendDateRange = false,
    annualizedSpendMessage?: string,
    potentialSavingsMessage?: string,
    isPotentialSavingsVisible = true,
  ): Observable<DateRange> {
    const modal = this.modalService.open(DateRangePickerModalComponent, {
      size: 'xl',
      ariaLabelledBy: 'modal-basic-title',
      centered: true,
    });

    const modalInstance: DateRangePickerModalComponent =
      modal.componentInstance;

    modalInstance.dateRangeBounds = dateRangeBounds;
    modalInstance.selectedDateRange = selectedDateRange;
    modalInstance.minSelectionCount = minSelectionCount;
    modalInstance.maxSelectionCount = maxSelectionCount;
    modalInstance.hasCustomSpendDateRange = hasCustomSpendDateRange;
    modalInstance.annualizedSpendMessage = annualizedSpendMessage;
    modalInstance.potentialSavingsMessage = potentialSavingsMessage;
    modalInstance.isPotentialSavingsVisible = isPotentialSavingsVisible;

    modal.closed.subscribe((value) => {
      return this.selectedDateRange$.next(value);
    });

    return modal.closed;
  }
}
